import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const MinusIcon: React.FC<IconProps> = (props) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </Icon>
);
